import PostcodeField from './PostcodeField';
export { PostcodeField as default };
